/* eslint-disable max-len */
import { AdminAuthRoutes } from '../../../submodules/common/enums/routes/admin-auth-routes.enum';
import { AdminUserRoutes } from '../../../submodules/common/enums/routes/admin-user-routes.enum';
import { AuthRoutes } from '../../../submodules/common/enums/routes/auth-routes.enum';
import { IAdminAdLoginRequestDTO } from '../../../submodules/common/interfaces/dto/auth/iadmin-ad-login-request.interface';
import { IAdminLoginRequestDTO } from '../../../submodules/common/interfaces/dto/auth/iadmin-login-request.interface';
import { IAdminLoginResponseDTO } from '../../../submodules/common/interfaces/dto/auth/iadmin-login-response.interfaces';
import { IApiResponseGenericDTO } from '../../../submodules/common/interfaces/dto/common/iapi-response.interface';
import { setGreetingIdUser, setSessionIdUser } from '../../reducers/authSlice';
import { EMethod } from '../utils';
import { adminApi } from './adminApi';

export const authApi = adminApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<IApiResponseGenericDTO<IAdminLoginResponseDTO>, IAdminLoginRequestDTO>({
      query: (body) => ({
        url: `${AuthRoutes.BasePrefix}/${AuthRoutes.Login}`,
        method: EMethod.POST,
        body,
      }),
    }),
    adLogin: builder.mutation<IApiResponseGenericDTO<IAdminLoginResponseDTO>, IAdminAdLoginRequestDTO>({
      query: (body) => ({
        url: `${AdminAuthRoutes.BasePrefix}/${AdminAuthRoutes.ActiveDirectoryLogin}`,
        method: EMethod.POST,
        body,
      }),
    }),
    recoveryUser: builder.mutation<IApiResponseGenericDTO<IAdminLoginResponseDTO>, undefined>({
      query: () => ({
        url: `${AdminUserRoutes.BasePrefix}/${AdminUserRoutes.RecoverUser}`,
        method: EMethod.GET,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }
      ) {
        await queryFulfilled.then(({ data: { data: { greeting, sessionId } } }) => {
          dispatch(setGreetingIdUser(greeting));
          dispatch(setSessionIdUser(sessionId));
        }).catch((e) => e);
      },
    }),
  }),
});


export const { useLoginMutation, useAdLoginMutation, useRecoveryUserMutation } = authApi;
